import MyTabs from "../../../components/MyTabs";
import CulturalLandmarks from "./CulturalLandmarks";
import ManMadeHeritage from "./ManMadeHeritage";
import NaturalHeritage from "./NaturalHeritage";

const BodyOfWork = (props) => {

    const tabs = [
        { id: "man-made-heritage", title: "Man Made Heritage", Component: ManMadeHeritage },
        { id: "natural-heritage", title: "Natural Heritage", Component: NaturalHeritage },
        { id: "cultural-landmark", title: "Cultural Landmarks", Component: CulturalLandmarks },

    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default BodyOfWork;